import * as React from "react";
import { twMerge } from "tailwind-merge";

export interface FormGridProps extends React.HTMLAttributes<HTMLDivElement> {
  cols?: { base?: 1 | 2 | 3 | 4; md?: 1 | 2 | 3 | 4; lg?: 1 | 2 | 3 | 4 };
  gap?: "sm" | "md" | "lg";
}

const gapClass = {
  sm: "gap-2",
  md: "gap-4",
  lg: "gap-6",
} as const;

function colsToClass(cols?: FormGridProps["cols"]) {
  if (!cols) return "";
  const base = cols.base ? `grid-cols-${cols.base}` : "";
  const md = cols.md ? `md:grid-cols-${cols.md}` : "";
  const lg = cols.lg ? `lg:grid-cols-${cols.lg}` : "";
  return [base, md, lg].filter(Boolean).join(" ");
}

export function FormGrid({ cols = { base: 1 }, gap = "lg", className, ...rest }: FormGridProps) {
  return <div {...rest} className={twMerge("grid", colsToClass(cols), gapClass[gap], className)} />;
}
